// "Chrome 156.0.8078.54" -> "Chrome 156": the build number identifies nothing
// and wraps the name onto a second line on a phone.
export const shortenVersion = browser =>
	(browser || '').replace(/\s(\d+)(\.\d+)+$/, ' $1')
